import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://www.velocityoffshore.com";

const seoData: Record<string, { title: string; description: string }> = {
  "/": {
    title: "Velocity Offshore | Offshore CTV & PSV Operations",
    description: "Proven offshore crew transfer vessel and PSV operations for deepwater energy provinces in West Africa, Caribbean, and South America.",
  },
  "/about": {
    title: "About Velocity Offshore | Offshore Marine Operations",
    description: "Decades of operational experience in high-speed offshore crew transportation for major oil and gas operators worldwide.",
  },
  "/services": {
    title: "Crew Transfer Services | CTV, PSV & Vessel Management",
    description: "Offshore personnel transportation, crew transfer vessel operations, PSV management, and ISM-certified safety services.",
  },
  "/fleet": {
    title: "Fleet | AIRCAT 35 High-Speed CTV & PSV",
    description: "Explore Velocity Offshore's AIRCAT 35 high-speed crew transfer vessels and PSVs. ABS classed, DPS-2, SOLAS / HSC Code compliant.",
  },
  "/operations": {
    title: "Global Marine Operations | Velocity Offshore",
    description: "Operating across West Africa, the Caribbean, and South America with reliable offshore crew transfer and logistics vessel services.",
  },
  "/safety": {
    title: "Safety & Compliance | ISM, MLC, SOLAS & ISPS",
    description: "Zero harm, no compromise. ISM, MLC 2006, SOLAS / HSC, OVMSA, MARPOL compliant with ABS class and RMI flag state certification.",
  },
  "/contact": {
    title: "Contact Velocity Offshore | Crew Transfer Enquiries",
    description: "Contact Velocity Offshore to discuss crew transfer vessel requirements. Offices in Houston, TX and Majuro, Marshall Islands.",
  },
  "/fleet-brochure": {
    title: "Meet Our Fleet | Velocity Offshore Vessel Brochure",
    description: "Printable brochure of the Velocity Offshore fleet: AIRCAT high-speed crew transfer vessels, modular carriers, autonomous USVs and IMO IBC Type 1 PSVs.",
  },
  "/brand": {
    title: "Brand Assets | Velocity Offshore",
    description: "Download Velocity Offshore brand assets, including logos, wordmarks, and color palettes for press and partner use.",
  },
  "/terms": {
    title: "Terms of Service | Velocity Offshore",
    description: "Read the Velocity Offshore terms of service governing use of our website, portals, and digital services.",
  },
  "/privacy": {
    title: "Privacy Policy | Velocity Offshore",
    description: "Learn how Velocity Offshore collects, uses, and protects personal information across our websites and client portals.",
  },
  "/cookies": {
    title: "Cookie Policy | Velocity Offshore",
    description: "Details on how Velocity Offshore uses cookies and similar technologies across our websites and digital platforms.",
  },
};

const SEOHead = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const data = seoData[pathname];
    if (!data) return;

    document.title = data.title;

    const updateMeta = (selector: string, content: string) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute("content", content);
    };

    updateMeta('meta[name="description"]', data.description);
    updateMeta('meta[property="og:title"]', data.title);
    updateMeta('meta[property="og:description"]', data.description);
    updateMeta('meta[property="og:url"]', `${BASE_URL}${pathname}`);
    updateMeta('meta[name="twitter:title"]', data.title);
    updateMeta('meta[name="twitter:description"]', data.description);

    // Update canonical
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (canonical) {
      canonical.href = `${BASE_URL}${pathname}`;
    }
  }, [pathname]);

  return null;
};

export default SEOHead;
